import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";
import BG from "../../assets/images/t-one.png";
import Avatar from "../../assets/images/four.png";
import "../../Styles/Profile.css";
import { FaFacebook } from "react-icons/fa";
import { FaGithub } from "react-icons/fa";
import { CiInstagram } from "react-icons/ci";
import { FaTwitterSquare } from "react-icons/fa";
import { FaRegEdit } from "react-icons/fa";
import { RiCameraFill } from "react-icons/ri";
import { useAppContext } from "../../services/context";
import { format, parseISO } from "date-fns";
import { toast } from "sonner";
import {
  addUpdateProfilePic,
  getCities,
  getCountries,
  getProvinces,
  haveToCheckEmail,
} from "../employees/helpers";
import {
  fetchEmployeeById,
  updateEmployee,
} from "../../services/axios/apiManager";
import { handleErrors, setUserData } from "../../services/dataManager";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { personalDetailsValidations } from "./profileValidations";
import { baseURL } from "../../services/axios/eps";
import ChangePassword from "./changePassword";
import PersonalDetails from "./personalDetails";
import ProfileTabs from "./profileTabs";
import Education from "./education";
import SecurityAndPrivacy from "./securityAndPrivacy";
import LoadingSpinner from "../../Components/spinner";

function AdminProfile() {
  const { state, setState } = useAppContext();
  const { user } = state;

  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [countries, setCountries] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [empData, setEmpData] = useState({});
  const [empEmail, setEmpEmail] = useState("");
  const [imageURL, setImageURL] = useState(null);
  console.log("empData :", empData);

  const handleImageChange = async (e) => {
    e.preventDefault();
    if (e?.target?.files && e.target.files[0]) {
      const file = e.target.files[0];
      await addUpdateProfilePic(user?.id, file, navigate);
      const previewUrl = URL.createObjectURL(file);
      setImageURL(previewUrl);
      const res = await fetchEmployeeById(user?.id);
      if (res?.data?.success && res?.data?.data) {
        setUserData(res.data.data);
        setState((prev) => ({ ...prev, user: res.data.data }));
      }
    } else {
      setImageURL(null);
    }
  };

  const formik = useFormik({
    initialValues: {
      first_name: empData?.first_name || "",
      last_name: empData?.last_name || "",
      email: empData?.email || "",
      mobile_number: empData?.mobile_number || "",
      landline_number: empData?.landline_number || "",
      date_of_birth: empData?.date_of_birth || "",
      emergency_contact_name: empData?.emergency_contact_name || "",
      emergency_contact_number: empData?.emergency_contact_number || "",
      address_line_1: empData?.address_line_1 || "",
      address_line_2: empData?.address_line_2 || "",
      country_id: empData?.country_id || "",
      province_id: empData?.province_id || "",
      city_id: empData?.city_id || "",
      zip_code: empData?.zip_code || "",
    },
    validationSchema: personalDetailsValidations,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const isEmailExists = await haveToCheckEmail(
          values,
          empEmail,
          navigate
        );
        if (isEmailExists) {
          formik.setFieldError("email", "Email already exists");
          return;
        }

        const res = await updateEmployee(user?.id, values);
        if (res?.data?.success) {
          toast.success("Profile has been updated", { duration: 2000 });
        } else {
          handleErrors(res, navigate, "Update Profile: ");
        }
      } catch (error) {
        console.log("Error Upon form submition", error);
      } finally {
        setLoading(false);
      }
    },
  });

  const getData = async () => {
    await getCountries(setCountries, navigate);
    if (user?.id) {
      const res = await fetchEmployeeById(user.id);
      if (res?.data?.success && res?.data?.data) {
        setEmpData(res.data.data);
        setEmpEmail(res.data.data.email);
        const { province_id, country_id } = res.data.data;
        if (country_id) {
          await getProvinces(country_id, setProvinces, navigate);
        }
        if (province_id) {
          await getCities(province_id, setCities, navigate);
        }
      } else {
        handleErrors(res, navigate);
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <DashboardLayout>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div className="mt-3 me-2" data-testid="loading-spinner">
            <LoadingSpinner size="lg" />
          </div>
        </div>
      ) : (
        <>
          <div className="row">
            <div className="col-xxl-3">
              <div className="card overflow-hidden">
                <div>
                  <img
                    src={Avatar}
                    alt=""
                    className="card-img-top profile-wid-img object-fit-cover"
                    style={{ height: 200 }}
                  />
                  <div className="bg-success">
                    <input
                      id="profile-foreground-img-file-input"
                      type="file"
                      className="profile-foreground-img-file-input d-none"
                    />
                  </div>
                </div>
                <div className="card-body pt-0 mt-[-2rem]">
                  <div className="text-center">
                    <div className="profile-user position-relative d-inline-block mx-auto">
                      <img
                        crossorigin="anonymous"
                        src={
                          imageURL
                            ? imageURL
                            : empData?.image
                              ? `${baseURL}/uploads/file/${empData?.image}`
                              : BG
                        }
                        alt="User Avatar"
                        className="avatar-lg rounded-circle object-fit-cover img-thumbnail user-profile-image"
                        style={{
                          maxHeight: "200px",
                          minHeight: "150px",
                          width: "150px",
                          border: "5px solid #ccc",
                          objectFit: "contain",
                        }}
                      />
                      <div className="avatar-xs p-0 rounded-circle profile-photo-edit position-absolute end-0 bottom-0">
                        <input
                          id="profile-img-file-input"
                          type="file"
                          data-testid="profImg"
                          className="profile-img-file-input d-none"
                          onChange={handleImageChange}
                        />
                        <label
                          htmlFor="profile-img-file-input"
                          className="profile-photo-edit avatar-xs"
                          style={{ cursor: "pointer" }}
                        >
                          <span
                            className="avatar-title rounded-circle bg-light text-body border shadow-sm d-flex align-items-center justify-content-center bg-dark"
                            style={{
                              width: "35px",
                              height: "35px",
                              border: "2px solid #aaa",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                              transition: "0.3s",
                            }}
                          >
                            <RiCameraFill size={18} />
                          </span>
                        </label>
                      </div>
                    </div>
                    <div className="mt-3">
                      <h5 className="mb-0">
                        {`${user?.first_name || ""} ${user?.last_name || ""}`}
                        <i className="bi bi-patch-check-fill align-baseline text-info ms-1" />
                      </h5>
                      <p className="text-secondary">
                        {empData?.role?.name || ""}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card-body border-top">
                  <div className="d-flex align-items-center mb-4 pb-2">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-0">Complete Your Profile</h5>
                    </div>
                    <div className="flex-shrink-0">
                      <a
                        href="#"
                        className="badge bg-success text-light text-decoration-none"
                        onClick={() => setIsEditing((prev) => !prev)}
                      >
                        <i className="ri-edit-box-line align-bottom me-1" />{" "}
                        {isEditing ? "Update" : "Edit"}
                      </a>
                    </div>
                  </div>
                  <div className="progress animated-progress custom-progress progress-label">
                    <div
                      className="progress-bar bg-success"
                      role="progressbar"
                      style={{ width: "66%" }}
                      aria-valuenow={30}
                      aria-valuemin={0}
                      aria-valuemax={100}
                    >
                      <div className="label">66%</div>
                    </div>
                  </div>
                </div>
                <div className="card-body border-top">
                  <div className="d-flex align-items-center mb-4">
                    <div className="flex-grow-1">
                      <h5 className="card-title mb-0">Social</h5>
                    </div>
                    <div className="flex-shrink-0 text-light">
                      <a
                        href="#"
                        className="badge bg-success text-light text-decoration-none"
                      >
                        <i className="ri-add-fill align-bottom me-1" /> Add
                      </a>
                    </div>
                  </div>
                  <div className="mb-3 d-flex">
                    <div className="avatar-xs d-block flex-shrink-0 me-3">
                      <span className="avatar-title rounded-circle bg-dark-subtle text-dark">
                        <FaGithub size={28} />
                      </span>
                    </div>
                    <input
                      type="email"
                      className="bg-dark text-light border-light input-placeholder-light form-control"
                      id="gitUsername"
                      placeholder="Username"
                      defaultValue="@"
                    />
                  </div>

                  <div className="mb-3 d-flex">
                    <div className="avatar-xs d-block flex-shrink-0 me-3">
                      <span className="avatar-title rounded-circle bg-primary-subtle text-primary">
                        <FaFacebook size={28} />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="bg-dark text-light border-light input-placeholder-light form-control"
                      id="websiteInput"
                      placeholder="www.example.com"
                      defaultValue="www.facebook.com"
                    />
                  </div>

                  <div className="mb-3 d-flex">
                    <div className="avatar-xs d-block flex-shrink-0 me-3">
                      <span className="avatar-title rounded-circle bg-success-subtle text-success">
                        <FaTwitterSquare size={28} />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="bg-dark text-light border-light input-placeholder-light form-control"
                      id="dribbleName"
                      placeholder="Username"
                      defaultValue="@"
                    />
                  </div>

                  <div className="d-flex">
                    <div className="avatar-xs d-block flex-shrink-0 me-3">
                      <span className="avatar-title rounded-circle bg-danger-subtle text-danger">
                        <CiInstagram size={28} />
                      </span>
                    </div>
                    <input
                      type="text"
                      className="bg-dark text-light border-light input-placeholder-light form-control"
                      id="pinterestName"
                      placeholder="Username"
                      defaultValue=""
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-9 card p-4 rounded mb-4 text-light"
              style={{ border: "none", background: "#0a1117" }}
            >
              <div className="d-flex align-items-center flex-wrap gap-2 mb-4">
                <div className="flex-shrink-0 ms-auto order-1 order-lg-2">
                  <button
                    className="btn btn-success d-flex align-items-center gap-2"
                    onClick={() => setIsEditing((prev) => !prev)}
                  >
                    <FaRegEdit className="me-1" />{" "}
                    {isEditing ? "Go Back" : "Edit Profile"}
                  </button>
                </div>
              </div>

              <div>
                <div>
                  {isEditing ? (
                    <div>
                      <ProfileTabs />

                      <div className="tab-content">
                        <PersonalDetails
                          empData={empData}
                          countries={countries}
                          provinces={provinces}
                          cities={cities}
                          getProvinces={getProvinces}
                          getCities={getCities}
                        />

                        <div
                          className="tab-pane"
                          id="changePassword"
                          role="tabpanel"
                        >
                          <div
                            action=""
                            className="card-header bg-dark text-white py-3 card shadow-lg border-0 rounded-2"
                          >
                            <div className="card-body">
                              <div className="row">
                                <ChangePassword empData={empData} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <Education />

                        <SecurityAndPrivacy />
                      </div>
                    </div>
                  ) : (
                    <div className="tab-content">
                      <div
                        className="tab-pane active"
                        id="personalDetails"
                        role="tabpanel"
                      >
                        <div className="card shadow-lg border-0 rounded-2" >
                          <div className="card-header bg-dark text-white py-3" data-testid= "pageHeading">
                            <h5 className="card-title mb-0 fs-4 fw-bold" >
                              Personal Details
                            </h5>
                          </div>

                          <div className="card-body bg-dark text-white">
                            <div className="row g-4">
                              {[
                                {
                                  label: "First Name",
                                  value: empData?.first_name || "",
                                },
                                {
                                  label: "Last Name",
                                  value: empData?.last_name || "",
                                },
                                {
                                  label: "Email Address",
                                  value: empData?.email || "",
                                },
                                {
                                  label: "Mobile Number",
                                  value: empData?.mobile_number || "",
                                },
                                {
                                  label: "Landline Number",
                                  value: empData?.landline_number || "",
                                },
                                {
                                  label: "Birth Date",
                                  value: empData?.date_of_birth
                                    ? format(user.date_of_birth, "PP")
                                    : "",
                                },
                                {
                                  label: "Joining Date",
                                  value: empData?.joining_date
                                    ? format(user.joining_date, "PP")
                                    : "",
                                },
                                {
                                  label: "Designation",
                                  value: empData?.designation?.title || "",
                                },
                                {
                                  label: "Emergency Contact Name",
                                  value: empData?.emergency_contact_name || "",
                                },
                                {
                                  label: "Emergency Contact Number",
                                  value:
                                    empData?.emergency_contact_number || "",
                                },
                              ].map((item, index) => (
                                <div className="col-lg-6" key={index}>
                                  <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                    <span className="text-secondary fs-6 fw-semibold">
                                      {item.label}
                                    </span>
                                    <span
                                      className={`d-block fs-5 fw-medium ${!item?.value && "text-danger"}`}
                                    >
                                      {item.value || "N/A"}
                                    </span>
                                  </div>
                                </div>
                              ))}

                              <div className="col-lg-12">
                                <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                  <span className="text-secondary fs-6 fw-semibold">
                                    Address
                                  </span>
                                  <span className="d-block fs-5 fw-medium">
                                    {`${empData?.address_line_1 || ""} ${empData?.address_line_2 || ""}`}
                                  </span>
                                </div>
                              </div>
                              {[
                                {
                                  label: "Country",
                                  value: empData?.country?.country_name || "",
                                },
                                {
                                  label: "Province",
                                  value: empData?.province?.province_name || "",
                                },
                                {
                                  label: "City",
                                  value: empData?.city?.city_name || "",
                                },
                                {
                                  label: "Zip Code",
                                  value: empData?.zip_code || "",
                                },
                              ].map((item, index) => (
                                <div className="col-lg-6" key={index}>
                                  <div className="p-3 bg-secondary bg-opacity-10 rounded">
                                    <span
                                      className={`d-block fs-5 fw-medium ${!item?.value && "text-danger"}`}
                                    >
                                      {item.label}
                                    </span>
                                    <span className="d-block fs-5 fw-medium">
                                      {item.value}
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  );
}

export default AdminProfile;
